import request from 'src/network';
import { compressImageService, fileToBase64 } from './AssetService';

const apiPath = '/api/ai_agent/ask_images';

export async function imageQuestionService(data: {question: string, images: File[]}) {
    const filesCompressed = await Promise.all(data.images.map((file) => compressImageService(file)));
    const filesCompressedBase64 = await Promise.all(
        filesCompressed.map(async (file) => {
            const image = await fileToBase64(file);
            return image;
        }),
    );
    const response = await request.POST(apiPath, { question: data.question, images: filesCompressedBase64 });
    return response;
}